/**
 * @generated SignedSource<<ee774fba77bede749e5a4e3ffdf917b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FiltersForCompetitionApprovalsFragment$data = {
  readonly viewerCanApprove: boolean;
  readonly " $fragmentType": "FiltersForCompetitionApprovalsFragment";
};
export type FiltersForCompetitionApprovalsFragment$key = {
  readonly " $data"?: FiltersForCompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersForCompetitionApprovalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FiltersForCompetitionApprovalsFragment",
  "selections": [
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "f01b4d548bfe38dfa54face7e93ad2c4";

export default node;
